import i18n from 'i18next'

class ChartType {
    chartType

    toJSON() {
        return this.chartType
    }

    static getOptions = (questionType, kpiType, hasNumericCodes) => {
        const options = [
            {
                label: 'Verbatim',
                name: 'chartType',
                value: 'verbatim',
                filter: () => (
                    ['TA', 'TX'].includes(questionType)
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.kpiChart'),
                name: 'chartType',
                value: 'kpiChart',
                filter: () => (
                    !['TB', 'RT', 'SG'].includes(questionType)
                    && kpiType !== 'NPS'
                    && hasNumericCodes
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.nps'),
                name: 'chartType',
                value: 'npsChart',
                filter: () => (
                    kpiType === 'NPS'
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.standardColumn'),
                name: 'chartType',
                value: 'standardColumn',
                filter: () => (
                    ['KPI', 'OD', 'RD', 'CH', 'SB', 'PC'].includes(questionType)
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.standardBar'),
                name: 'chartType',
                value: 'standardBar',
                filter: () => (
                    ['KPI', 'OD', 'RD', 'RT', 'CH', 'SB', 'PC'].includes(questionType)
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.stackedBar'),
                name: 'chartType',
                value: 'stackedBar',
                filter: () => (
                    ['KPI', 'OD', 'TB', 'SG'].includes(questionType)
                    || kpiType === 'NPS'
                ),
            },
            {
                label: i18n.t('powerpoint.options.chart.stackedColumn'),
                name: 'chartType',
                value: 'stackedColumn',
                filter: () => (
                    ['KPI', 'OD'].includes(questionType)
                    || kpiType === 'NPS'
                ),
            },
        ]

        return options.filter(({ filter }) => filter())
    }
}

export default ChartType
